// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__yW4Uj","small":"Avatar_small__cIJyU","medium":"Avatar_medium__rzsd0","large":"Avatar_large__97c9f"};